const logs = {
  name: 'Registros del dispositivo',
  title: 'Registros del dispositivo',
  selectGroup: 'Grupo',
  selectGroupHint: 'Seleccione un grupo para filtrar instalaciones',
  selectHotel: 'Instalación',
  selectHotelHint: 'Seleccione una instalación para filtrar dispensadores',
  selectDevice: 'Seleccionar un dispositivo',
  selectDeviceHint: 'Seleccione un dispositivo para ver sus registros',
  noDeviceSelected: 'Ningún dispositivo seleccionado',
  noDeviceSelectedHint: 'Seleccione un dispositivo desde Filtros para ver sus registros.',
  noLogs: 'No se encontraron registros para este dispositivo',
  noLogsHint: 'Es posible que el dispositivo aún no haya enviado registros, o que el servidor de registros no esté disponible.',
  seqError: 'No se pudieron obtener los registros del dispositivo',
  unavailable: 'Los registros del dispositivo no están disponibles en este momento. Inténtelo de nuevo más tarde.',
  level: 'Nivel',
  allLevels: 'Todos los niveles',
  from: 'Desde',
  to: 'Hasta',
  count: 'Máx. resultados',
  refresh: 'Actualizar',
  component: 'Componente',
  origin: 'Origen',
  firmware: 'Firmware',
  serialNumber: 'Número de serie',
  result: 'Resultado',
  transaction: 'Transacción',
  steps: 'Pasos',
  step: 'Paso %{number}',
  properties: 'Propiedades',
  loading: 'Cargando registros...',
  loadingInitial: 'Cargando dispositivos...',

  // Tabs
  tabs: {
    device: 'Dispositivos',
    processing: 'Flujos',
    errors: 'Errores',
    apicalls: 'Llamadas API',
    search: 'Búsqueda',
  },

};
export default logs;
